import CloseIcon from "@mui/icons-material/Close";
import { Col, Button, Dropdown } from "react-bootstrap";
import Modal from "@mui/material/Modal";
import { useState, useEffect, useContext } from "react";
import axios from "axios";
import Autocomplete from "@mui/material/Autocomplete";
import AddIcon from "@mui/icons-material/Add";
import Box from "@mui/material/Box";
import Toast from "react-bootstrap/Toast";
import { AuthContext } from "../../../context/AuthContext";
import MONTHS from "../../../context/Months";
import TextField from "@mui/material/TextField";
import Cities from "../../../context/Cities";
import Months from "../../../context/Months";
import Years from "../../../context/Years";
import Checkbox from "@mui/material/Checkbox";
import { Avatar } from "@mui/material";
import MoreVert from "@mui/icons-material/MoreVert";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Rating from "@mui/material/Rating";
import { Link, useParams } from "react-router-dom";
import React from "react";
import FetchFingerprint from "../../../actions/FetchFingerprint";
import ENDPOINT from "../../../data/ENDPOINT";
import { School } from "@mui/icons-material";
const EducationList = () => {
  const params = useParams();
  const username = params.username;
  const { user } = useContext(AuthContext);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [title, settitle] = useState(null);
  const [description, setdescription] = useState(null);

  const [privacy, setprivacy] = useState(null);
  const [education, seteducation] = useState(null);

  const SaveEducation = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("session", user.SessionId);
    formData.append("fp", FetchFingerprint());
    formData.append("college", title);
    formData.append("degree", description);
    formData.append("start_month", startmonth);
    formData.append("end_month", endmonth);
    formData.append("start_year", startyear);
    formData.append("end_year", endyear);
    formData.append("privacy", privacy);
    formData.append("field_of_study", studyfield);
    formData.append("degree", description);
    const res = await axios.post(
      `${ENDPOINT}user-education-add.php`,
      formData,
      {
        headers: { "content-type": "multipart/form-data" },
      },
    );

    if (res) {
      //  //  //  //console.log("added "+JSON.stringify(res));
      if (res.data.status === "success") {
        settoasttitle("Education added successfully");
        settoast(true);
        Fetch_education();
        setaddeducation(false);
        ClearData();
      } else {
      }
      //  //  //  //console.log(JSON.stringify(res))
    }
  };

  const [self, setself] = useState(false);
  const Fetch_education = async () => {
    const formdata = new FormData();
    formdata.append("session", user.SessionId);
    formdata.append("fp", FetchFingerprint());
    formdata.append("username", username);
    const res = await axios.post(`${ENDPOINT}user-education.php`, formdata, {
      headers: { "content-type": "multipart/form-data" },
    });
    if (res.data) {
      //  //console.log("education is "+JSON.stringify(res))
      if (res.data.status === "success") {
        if (res.data.data !== null || res.data.data !== "null") {
          seteducation(res.data.data);
          setself(res.data.self);
        }
      }
    }
  };

  const [editid, seteditid] = useState(null);
  const Edit = async ({ id, action }) => {
    const formdata = new FormData();
    formdata.append("session", user.SessionId);
    formdata.append("fp", FetchFingerprint());
    formdata.append("id", id);
    if (action === "get") {
      formdata.append("get", true);
    } else {
      formdata.append("college", title);
      formdata.append("degree", description);
      formdata.append("start_month", startmonth);
      formdata.append("end_month", endmonth);
      formdata.append("start_year", startyear);
      formdata.append("end_year", endyear);
      formdata.append("privacy", privacy);
      formdata.append("field_of_study", studyfield);
      formdata.append("degree", description);
    }
    const res = await axios.post(
      "https://skillsuprise.com/user-education-edit.php",
      formdata,
      {
        headers: { "content-type": "multipart/form-data" },
      },
    );
    if (res) {
      //  //  //  //console.log("edit "+JSON.stringify(res))
      if (res.data.status === "success") {
        if (res.data.data === null) {
          settoasttitle("Edit successful");
          settoast(true);
          setedit(false);
          ClearData();
          Fetch_education();
        } else {
          if (action === "get") {
            setedit(true);
          }
          const data = res.data.data[0];
          settitle(data.college);
          setdescription(data.degree);
          setstudyfield(data.field_of_study);
          setendyear(data.end_year);
          setendmonth(data.end_month);
          setstartyear(data.start_year);
          setstartmonth(data.start_month);
          setprivacy(data.privacy);
          seteditid(data.id);
        }
      }
    }
  };

  useEffect(() => {
    Fetch_education();
  }, []);
  const Delete = async ({ education_id }) => {
    const data = new FormData();
    data.append("id", education_id);
    data.append("session", user.SessionId);
    data.append("fp", FetchFingerprint());
    const res = await axios.post(`${ENDPOINT}user-education-delete.php`, data, {
      headers: { "content-type": "multipart/form-data" },
    });
    if (res) {
      //  //  //  //console.log(JSON.stringify(res))
      if (res.data.status === "success") {
        settoasttitle("Deleted successfully");
        settoast(true);

        Fetch_education();
      }
    }
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",

    bgcolor: "background.paper",

    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
  };

  const [addeducation, setaddeducation] = useState(false);
  const defaultProps = {
    options: MONTHS,
    getOptionLabel: (option) => option.name,
  };

  const [startmonth, setstartmonth] = useState(null);
  const [startyear, setstartyear] = useState(null);
  const [endyear, setendyear] = useState(null);
  const [endmonth, setendmonth] = useState(null);
  const [studyfield, setstudyfield] = useState(null);
  const [city, setcity] = useState(null);
  const [presentstatus, setpresentstatus] = useState(false);
  const [edit, setedit] = useState(false);

  const [toast, settoast] = useState(false);

  const [toasttitle, settoasttitle] = useState(null);
  const [toastmessage, settoastmessage] = useState(null);

  const ClearData = () => {
    settitle(null);
    setdescription(null);
    setstudyfield(null);
    setendyear(null);
    setendmonth(null);
    setstartyear(null);
    setstartmonth(null);
  };
  return (
    <>
      <div className="toast-container">
        <Toast
          className="bg-warning"
          onClose={() => settoast(false)}
          show={toast}
          delay={3000}
          autohide
        >
          <Toast.Header>
            <img
              src="holder.js/20x20?text=%20"
              className="rounded me-2"
              alt=""
            />
            <strong className="me-auto">{toasttitle}</strong>
          </Toast.Header>
          <Toast.Body>{toastmessage}</Toast.Body>
        </Toast>
      </div>

      <Modal open={edit} onClose={() => setedit(false)}>
        <Box
          className="col-lg-5 col-md-6 rounded col-sm-6 col-11 p-3"
          sx={style}
        >
          <div className="w-100">
            <div className="flex align-items-center space-between">
              <h4>Add Education</h4>
              <CloseIcon
                type="button"
                onClick={() => {
                  setedit(false);
                }}
              />
            </div>
            <hr />
            <form
              method="post"
              onSubmit={(e) => {
                e.preventDefault();
                Edit({ id: editid, action: "edit" });
              }}
            >
              <label className="mt-1 w-100 me-3">School/College</label>
              <input
                required
                minLength={3}
                maxLength={200}
                className="  form-control me-3"
                type="text"
                value={title}
                onChange={(e) => {
                  settitle(e.target.value);
                }}
                name="title"
              ></input>
              <br />
              <label className="mt-1 me-3">Degree</label>
              <input
                placeholder="Ex: Bachelors Degree"
                required
                minLength={2}
                maxLength={50}
                className=" form-control me-3"
                type="text"
                value={description}
                onChange={(e) => {
                  setdescription(e.target.value);
                }}
                name="description"
              ></input>
              <br />

              <label className="mt-1 me-3">Field of study</label>
              <input
                required
                minLength={2}
                maxLength={50}
                placeholder="Ex: Computer Science"
                className=" form-control me-3"
                type="text"
                value={studyfield}
                onChange={(e) => {
                  setstudyfield(e.target.value);
                }}
                name="description"
              ></input>
              <br />
              <label className="mt-1 me-3">Start Date</label>
              <div className="flex w-100">
                <div className="col pl-0">
                  <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    options={Months}
                    disableClearable
                    value={startmonth}
                    onChange={(event, newValue) => {
                      setstartmonth(newValue);
                    }}
                    inputValue={startmonth}
                    onInputChange={(event, newInputValue) => {
                      setstartmonth(newInputValue);
                    }}
                    renderInput={(params) => (
                      <TextField required {...params} label="Month" />
                    )}
                  />
                </div>

                <div className="col pr-0">
                  <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    options={Years}
                    disableClearable
                    value={startyear}
                    onChange={(event, newValue) => {
                      setstartyear(newValue);
                    }}
                    inputValue={startyear}
                    onInputChange={(event, newInputValue) => {
                      setstartyear(newInputValue);
                    }}
                    renderInput={(params) => (
                      <TextField required {...params} label="Year" />
                    )}
                  />
                </div>
              </div>

              <div className="flex align-items-center mt-1 mb-1">
                <Checkbox
                  onClick={() => setpresentstatus(!presentstatus)}
                  value={presentstatus}
                />
                <p className="mb-0">Currently Studying</p>
              </div>

              {presentstatus ? (
                <></>
              ) : (
                <>
                  <label className="mt-1 me-3">End Date</label>
                  <div className="flex w-100">
                    <div className="col pl-0">
                      <Autocomplete
                        disablePortal
                        options={Months}
                        disableClearable
                        value={endmonth}
                        onChange={(event, newValue) => {
                          setendmonth(newValue);
                        }}
                        inputValue={endmonth}
                        onInputChange={(event, newInputValue) => {
                          setendmonth(newInputValue);
                        }}
                        renderInput={(params) => (
                          <TextField {...params} label="Month" />
                        )}
                      />
                    </div>

                    <div className="col pr-0">
                      <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={Years}
                        disableClearable
                        value={endyear}
                        onChange={(event, newValue) => {
                          setendyear(newValue);
                        }}
                        inputValue={endyear}
                        onInputChange={(event, newInputValue) => {
                          setendyear(newInputValue);
                        }}
                        renderInput={(params) => (
                          <TextField {...params} label="Year" />
                        )}
                      />
                    </div>
                  </div>
                </>
              )}

              <Button variant="btn btn-waring w-100 mt-2" type="submit">
                Save Changes
              </Button>
            </form>
          </div>
        </Box>
      </Modal>

      <Modal open={addeducation} onClose={() => setaddeducation(false)}>
        <Box className="col-lg-5 col-md-6 col-sm-6 col-11 p-3" sx={style}>
          <div className="w-100">
            <div className="flex align-items-center space-between">
              <h4>Add Education</h4>
              <CloseIcon
                type="button"
                onClick={() => {
                  setaddeducation(false);
                }}
              />
            </div>
            <hr />
            <form method="post" onSubmit={SaveEducation}>
              <label className="mt-1 w-100 me-3">School/College</label>
              <input
                required
                minLength={3}
                maxLength={200}
                className="  form-control me-3"
                type="text"
                value={title}
                onChange={(e) => {
                  settitle(e.target.value);
                }}
                name="title"
              ></input>
              <br />
              <label className="mt-1 me-3">Degree</label>
              <input
                placeholder="Ex: Bachelors Degree"
                required
                minLength={2}
                maxLength={50}
                className=" form-control me-3"
                type="text"
                value={description}
                onChange={(e) => {
                  setdescription(e.target.value);
                }}
                name="description"
              ></input>
              <br />

              <label className="mt-1 me-3">Field of study</label>
              <input
                required
                minLength={2}
                maxLength={50}
                placeholder="Ex: Computer Science"
                className=" form-control me-3"
                type="text"
                value={studyfield}
                onChange={(e) => {
                  setstudyfield(e.target.value);
                }}
                name="description"
              ></input>
              <br />
              <label className="mt-1 me-3">Start Date</label>
              <div className="flex w-100">
                <div className="col pl-0">
                  <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    options={Months}
                    disableClearable
                    value={startmonth}
                    onChange={(event, newValue) => {
                      setstartmonth(newValue);
                    }}
                    inputValue={startmonth}
                    onInputChange={(event, newInputValue) => {
                      setstartmonth(newInputValue);
                    }}
                    renderInput={(params) => (
                      <TextField required {...params} label="Month" />
                    )}
                  />
                </div>

                <div className="col pr-0">
                  <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    options={Years}
                    disableClearable
                    value={startyear}
                    onChange={(event, newValue) => {
                      setstartyear(newValue);
                    }}
                    inputValue={startyear}
                    onInputChange={(event, newInputValue) => {
                      setstartyear(newInputValue);
                    }}
                    renderInput={(params) => (
                      <TextField required {...params} label="Year" />
                    )}
                  />
                </div>
              </div>

              <div className="flex align-items-center mt-1 mb-1">
                <Checkbox
                  onClick={() => setpresentstatus(!presentstatus)}
                  value={presentstatus}
                />
                <p className="mb-0">Currently Studying</p>
              </div>

              {presentstatus ? (
                <></>
              ) : (
                <>
                  <label className="mt-1 me-3">End Date</label>
                  <div className="flex w-100">
                    <div className="col pl-0">
                      <Autocomplete
                        disablePortal
                        options={Months}
                        disableClearable
                        value={endmonth}
                        onChange={(event, newValue) => {
                          setendmonth(newValue);
                        }}
                        inputValue={endmonth}
                        onInputChange={(event, newInputValue) => {
                          setendmonth(newInputValue);
                        }}
                        renderInput={(params) => (
                          <TextField {...params} label="Month" />
                        )}
                      />
                    </div>

                    <div className="col pr-0">
                      <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={Years}
                        disableClearable
                        value={endyear}
                        onChange={(event, newValue) => {
                          setendyear(newValue);
                        }}
                        inputValue={endyear}
                        onInputChange={(event, newInputValue) => {
                          setendyear(newInputValue);
                        }}
                        renderInput={(params) => (
                          <TextField {...params} label="Year" />
                        )}
                      />
                    </div>
                  </div>
                </>
              )}

              <Button variant="btn btn-warning w-100 mt-2" type="submit">
                Save Changes
              </Button>
            </form>
          </div>
        </Box>
      </Modal>

      {education ? (
        <>
          <div className=" border br-5 sm-br-none sm-shadow-none p-3">
            <div className="flex space-between align-items-center education-header">
              <h4
                style={{ color: "rgb(234 88 12)", fontWeight: 700 }}
                className="mb-3 pt-2"
              >
                Education
              </h4>

              {self ? (
                <>
                  <button
                    style={{ background: "rgb(234 88 12) ", color: "#ffffff" }}
                    type="button"
                    onClick={() => setaddeducation(true)}
                    className="btn add-education-btn fw-bold shadow-sm"
                  >
                    ADD
                  </button>
                </>
              ) : null}
            </div>

            <Col lg={12} md={12} sm={12} xs={12} className=" rounded p-3 ">
              {education && Array.isArray(education) && education.length > 0 ? (
                <>
                  {education.map((edu) => (
                    <div key={edu.id} className="mt-3 mb-3">
                      <div
                        style={{
                          border: "1px solid #f5e3d6",
                          borderRadius: "12px",
                          padding: "16px",
                          backgroundColor: "#fff",
                        }}
                      >
                        <div
                          className="flex space-between align-items-start"
                          style={{ flexWrap: "wrap", gap: "12px" }}
                        >
                          <div
                            className="flex"
                            style={{ flex: 1, minWidth: "200px" }}
                          >
                            <div
                              className="education-icon"
                              style={{
                                width: 56,
                                height: 56,
                                borderRadius: "50%",
                                backgroundColor: "rgba(255,165,0,0.18)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                marginRight: 14,
                                flexShrink: 0,
                              }}
                            >
                              <School
                                style={{ color: "orange", fontSize: 28 }}
                              />
                            </div>
                            <div style={{ minWidth: 0, flex: 1 }}>
                              <h5
                                style={{
                                  margin: "0 0 8px 0",
                                  fontWeight: 700,
                                  color: "#292929",
                                  fontSize: "18px",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {edu.college}
                              </h5>
                              <div style={{ marginBottom: "8px" }}>
                                <Rating
                                  style={{
                                    margin: "6px 0 4px",
                                    color: "rgb(234 88 12)",
                                  }}
                                  name={`rating-${edu.id}`}
                                  value={3}
                                  size="small"
                                  readOnly
                                />
                              </div>
                              <p
                                style={{
                                  margin: "0 0 4px 0",
                                  fontSize: "16px",
                                  color: "#4b5055",
                                }}
                              >
                                {edu.degree}{" "}
                                {edu.field_of_study
                                  ? `(${edu.field_of_study})`
                                  : ""}
                              </p>
                              <p
                                style={{
                                  margin: "0",
                                  fontSize: "14px",
                                  color: "#585f65",
                                }}
                              >
                                {edu.start_month},{edu.start_year} -{" "}
                                {edu.end_month
                                  ? edu.end_month + ", " + edu.end_year
                                  : "Present"}
                              </p>
                            </div>
                          </div>

                          <div
                            className="flex flex-column align-items-end education-card-actions"
                            style={{
                              marginLeft: "12px",
                              textAlign: "center",
                              minWidth: "80px",
                            }}
                          >
                            {self ? (
                              <>
                                <div
                                  style={{
                                    marginBottom: "12px",
                                    display: "flex",
                                    gap: "12px",
                                    flexWrap: "wrap",
                                    justifyContent: "flex-end",
                                  }}
                                >
                                  <button
                                    type="button"
                                    style={{
                                      width: "44px",
                                      height: "44px",
                                      border: "2px solid #ff9800",
                                      borderRadius: "8px",
                                      backgroundColor: "#fff",
                                      cursor: "pointer",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      transition: "all 0.2s",
                                    }}
                                    onClick={() =>
                                      Edit({ id: edu.id, action: "get" })
                                    }
                                    aria-label="edit"
                                  >
                                    <EditIcon
                                      style={{
                                        fontSize: "20px",
                                        color: "#ff9800",
                                      }}
                                    />
                                  </button>
                                  <button
                                    type="button"
                                    style={{
                                      width: "44px",
                                      height: "44px",
                                      border: "2px solid #dc3545",
                                      borderRadius: "8px",
                                      backgroundColor: "#fff",
                                      cursor: "pointer",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      transition: "all 0.2s",
                                    }}
                                    onClick={() =>
                                      Delete({ education_id: edu.id })
                                    }
                                    aria-label="delete"
                                  >
                                    <DeleteIcon
                                      style={{
                                        fontSize: "20px",
                                        color: "#dc3545",
                                      }}
                                    />
                                  </button>
                                </div>
                              </>
                            ) : null}
                            {/* <small
                              style={{ color: "#9ca3af", fontSize: "12px" }}
                            >
                              Best
                            </small> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </>
              ) : (
                <>
                  {self ? (
                    <>
                      {!education || education.length === 0 ? (
                        <>
                          <div
                            onClick={() => setaddeducation(true)}
                            type="button"
                            className="flex text-primary align-items-center"
                          >
                            <AddIcon className="mr-2" />
                            <h6 className="mb-0 ">Add Education</h6>
                          </div>
                        </>
                      ) : null}
                    </>
                  ) : null}
                </>
              )}
            </Col>
          </div>
        </>
      ) : (
        <>
          <div className="border  br-5 sm-br-none  text-center mt-5 p-3">
            {education ? (
              <>
                <div className="flex space-between align-items-center">
                  <h4 className="mb-3 pt-2">Education</h4>

                  {self ? (
                    <>
                      <button
                        style={{
                          background: "rgb(234 88 12) ",
                          color: "#ffffff",
                        }}
                        type="button"
                        onClick={() => setaddeducation(true)}
                        className="btn add-education-btn fw-bold shadow-sm"
                      >
                        ADD
                      </button>
                    </>
                  ) : null}
                </div>
              </>
            ) : null}

            {self ? (
              <>
                <div className="container empty-profile-section ">
                  <h4
                    onClick={() => setaddeducation(true)}
                    className="btn  rounded-pill btn-outline-secondary"
                  >
                    Add Education
                  </h4>
                </div>
              </>
            ) : (
              <>
                <div className="text-center">
                  <h5 className="text-secondary">No Education Added</h5>
                </div>
              </>
            )}
          </div>
        </>
      )}
    </>
  );
};
export default EducationList;